
  import { Component, Vue } from 'vue-property-decorator';
  import i18n, { DEFAULT_LANGUAGE, LANGUAGE_KEY_NAME } from '@/plugins/i18n';

  @Component({
    components: {},
  })
  export default class PageFooter extends Vue {
    private languageSet = window.localStorage.getItem(LANGUAGE_KEY_NAME) || DEFAULT_LANGUAGE;

    isLanguage(language: string) {
      return this.languageSet.substring(0, 2) === language;
    }

    setLanguage(language: string) {
      window.localStorage.setItem(LANGUAGE_KEY_NAME, language);
      this.languageSet = language;
      i18n.locale = language;
    }
  }
